import {
	SimpleCrud,
	SimpleCrudProps,
} from "src/components/SimpleCrud";
import { useBusiness } from "src/hooks/redux/useBusiness";
import {
	addBusinessPriority,
	removeBusinessPriority,
	updateBusinessPriority,
} from "src/redux/actions/businessActions";
import { useDispatch } from "src/redux/store";

export const BusinessPrioritiesTab = () => {
	const dispatch = useDispatch();
	const { selectedBusiness, loading } = useBusiness();

	const handleSubmit: SimpleCrudProps["onCreateOrUpdate"] =
		(values, action, selected) => {
			if (action === "New")
				dispatch(addBusinessPriority(values));
			else if (action === "Edit")
				dispatch(updateBusinessPriority(values, selected));
		};

	const handleDelete: SimpleCrudProps["onDelete"] = (
		selected
	) => {
		dispatch(removeBusinessPriority(selected));
	};

	// Transform the array to match CrudValue type
	const prioridadesArray = selectedBusiness?.Prioridades 
		? [...new Set(selectedBusiness.Prioridades)].map((prioridad, index) => ({
			Nombre: typeof prioridad === 'string' ? prioridad : prioridad.Nombre || '',
			Activado: true,
			index
		}))
		: [];

	return (
		<SimpleCrud
			key={"Prioridades"}
			array={prioridadesArray}
			isLoading={loading}
			name={"Prioridad"}
			onCreateOrUpdate={handleSubmit}
			onDelete={handleDelete}
		/>
	);
};
